import "./DreamGarden.css";
import { useNavigate } from "react-router-dom";
import bgImage from "../../Images/GarvanaHome9.png"; // ⭐ Add image import

export default function DreamGarden() {
  const navigate = useNavigate();

  return (
    <div className="dream-wrapper">
      <div
        className="dream-box dream-hover"
        onClick={() => navigate("/contact")}
        style={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h1 className="dream-title">
          We Transform Your <span>Dream Garden</span> Into Reality
        </h1>
      </div>
    </div>
  );
}
